import { render, staticRenderFns } from "./RelatorioLPSImageModal.vue?vue&type=template&id=5a6d2032&scoped=true"
import script from "./RelatorioLPSImageModal.vue?vue&type=script&lang=js"
export * from "./RelatorioLPSImageModal.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLPSImageModal.vue?vue&type=style&index=0&id=5a6d2032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d2032",
  null
  
)

export default component.exports